export default "__VITE_ASSET__CqUnlSjL__"